import moment, { Moment } from 'moment';

export const DEFAULT_DATE_FORMAT = 'DD-MM-YYYY';

export const dateFromString = (stringDate: string, dateFormat?: string) =>
    moment(stringDate, dateFormat || DEFAULT_DATE_FORMAT);

/**
 * Add zero to month or day if the essential format does not have zeros
 */
function addZeroToDateEntity(dateEntity: string | number) {
    return Number(dateEntity) < 10 ? '0' + dateEntity : dateEntity;
}

export const stringDateFromArray = (date: string[]): string => {
    const [year, month, day] = date;
    return `${year}-${addZeroToDateEntity(month)}-${addZeroToDateEntity(day)}`;
};

export const toDateTime = (
    date: Moment,
    dateSeparator: string,
    utcToLocal = true
) => {
    let mDate = utcToLocal ? date.local() : date;

    return [
        mDate.format(`DD${dateSeparator}MM${dateSeparator}YYYY`),
        mDate.format('HH:mm'),
    ];
};

export const dateStringFromDateTimeString = (stringDate: string) =>
    stringDate.slice(0, 10);
